import Colors from '@/utils/Colors'
import AppUUIDsService from '@/services/AppUUIDsService'
import ToastNotification from '@/components/shared/components/vue-toastification/ToastNotification.vue'
import { loadLanguageAsync } from '@/plugins/i18n/i18n'
import { mapActions, mapGetters, mapState } from 'vuex'
import link from '@/utils/links'
import ImageModal from '@/components/shared/components/ImageModal.vue'
import { Languages } from '@/components/shared/enums/Languages'
import operation from '@/utils/operations'
import { EventBus } from '@/eventBus'
import { UserStates } from '@/components/conversations/enums/UserStates'
import PushNotificationsController from '@/controllers/PushNotificationsController'
import { StatusActive } from '@/Enums/StatusActive'

// components
import Loader from '@/shared/infrastructure/ui/Loader.vue'
import KBDrawer from '@/shared/infrastructure/ui/menus/KBDrawer/KBDrawer.vue'
import KeybeSidebar from '@/shared/infrastructure/ui/layout/KeybeSidebar/KeybeSidebar.vue'
import DownloadApp from '@/shared/infrastructure/ui/layout/DownloadApp.vue'
import KeybeFloatingContainer from '@/shared/infrastructure/ui/layout/KeybeFloatingContainer/KeybeFloatingContainer.vue'
import NotificationsScreen from '@/modules/NotificationsCenter/infrastructure/ui/NotificationsScreen/NotificationsScreen.vue'
import store from '@/store'
import AdviserStatusController from '@/modules/conversations/infrastructure/controllers/AdviserStatus.controller'
import EventsController from '@/shared/infrastructure/controllers/EventsController'
// import SignInOnboardingInitialInfo from '@/modules/SignInOnboarding/infrastructure/components/SignInOnboardingInitialInfo/SignInOnboardingInitialInfo.vue'
// import SignInOnboardingConfigStart from '@/modules/SignInOnboarding/infrastructure/components/SignInOnboardingConfigStart/SignInOnboardingConfigStart.vue'
import UserInfoCompletion from '@/shared/infrastructure/UserInfoCompletion/UserInfoCompletion.vue'
import {
  EventSuscriptionGetter,
  GraphqlEventTypes,
  onUser
} from '@/shared/domain/Events/Event'
import EventsUseCases from '@/shared/application/EventUseCases'
import OnboardingUseCases from '@/modules/SignInOnboarding/application/OnboardingUseCases'
import OnboardingController from '@/modules/SignInOnboarding/infrastructure/controllers/Onboarding.controller'
import { Step } from '@/modules/Sales/steps/domain/models/Steps'
import { Card } from '@/modules/Sales/cards/domain/models/Cards'

import Dialog from '@/components/shared/components/Dialog.vue'
import { dataToCheckUserOwner, dataToGetApp } from '@/modules/Apps/domain/AppsController'
import AppsUseCases from '@/modules/Apps/application/AppsUseCases'
import AppsController from '@/modules/Apps/infrastructure/controllers/Apps.controller'
import { dataToGetTermsByTeamMember } from '@/modules/Config/TeamConfiguration/domain/TeamController'
import TeamController from '@/modules/Config/TeamConfiguration/infrastructure/controllers/Team.controller'
import EventsApolloProvider from '@/modules/event/Providers/EventsApolloProvider'
import SubscriptionOnApp from '@/modules/Apps/infrastructure/graphql/subscription-on-app.graphql'
import { dataToGetUser } from '@/modules/Config/GeneralUserConfiguration/domain/UserController'
import UserUseCases from '@/modules/Config/GeneralUserConfiguration/application/UserUseCases'
import UserController from '@/modules/Config/GeneralUserConfiguration/infrastructure/controller/User.controller'
import { LoggedUserExtradata } from '@/modules/Config/GeneralUserConfiguration/domain/LoggedUser'
import Comissions from '@/modules/UserFloatingMenu/UserFloatingMenuContainer/ReferralsModal/ReferralsModal.vue'
import BikyStoreController from '@/modules/bky/infrastructure/persistence/BikyStore.controller'
import { BikyConfig } from '@/modules/bky/domain/BikyConfig'
import { BikyConfigUseCases } from '@/modules/bky/application/BikyConfigUseCases'
import BikyConfigController from '@/modules/bky/infrastructure/controllers/BikyConfig.controller'
import AuthService from '@/services/AuthService'
import SessionExtendModal from '@/shared/infrastructure/SessionExtendModal/SessionExtendModal.vue'
import VIdle from '@/shared/infrastructure/VIdle/VIdle.vue'
import ContactCallWhatsapp from '@/shared/infrastructure/ui/details/ContactCallWhatsapp/ContactCallWhatsapp.vue'
import ContactCall from '@/shared/infrastructure/ui/details/ContactCall/ContactCall.vue'
import { Contact } from '@/modules/CDP/shared/contacts/domain/Contact'
import NewVersionPopUp from '@/shared/infrastructure/ui/NewVersionPopUp/NewVersionPopUp.vue'

export default {
  name: 'App',
  components: {
    ImageModal,
    ToastNotification,
    Loader,
    KeybeSidebar,
    KBDrawer,
    NotificationsScreen,
    KeybeFloatingContainer,
    DownloadApp,
    // SignInOnboardingInitialInfo,
    // SignInOnboardingConfigStart,
    Dialog,
    Comissions,
    SessionExtendModal,
    VIdle,
    ContactCallWhatsapp,
    ContactCall
  },
  data () {
    return {
      Colors,
      mini: false,
      expanded: true,
      loadingApps: false,
      selectingCompany: false,
      oneSignalUserId: null,
      refreshing: false,
      notificationCenterOpen: false,
      extradata: {},
      eventsController: new EventsController(),
      onboardingController: new OnboardingController(),
      appsController: new AppsController(),
      teamController: new TeamController(),
      userController: new UserController(),
      bikyConfigController: new BikyConfigController(),
      UUID: AppUUIDsService,
      oneSignalRetryAttempts: 0,
      showOnboardingInitial: false,
      showOnboardingTutorial: false,
      showDragCardLostReason: false,
      showUserInfoCompletion: false,
      rerender: 0,
      draggedCard: {},
      indexDraggedCard: -1,
      toStep: {},
      fromStep: {},
      app: {},
      appSubscription: null,
      eventsApolloClient: EventsApolloProvider.getInstance().provider.defaultClient,
      showComissionsModal: false,
      sessionExtensionModal: false,
      callDialogWhatsapp: false,
      callDialog: false,
      selectedCallContact: null,
      selectedCallLine: null,
      x: (typeof window !== 'undefined' ? (Math.round(window.innerWidth / 2) - 200) : 100), // center of screen
      y: (typeof window !== 'undefined' ? (Math.round(window.innerHeight / 2) - 200) : 100),
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      showNewVersionPopUp: false
    }
  },
  computed: {
    ...mapState('UserStore', [
      'isLoggedIn',
      'isLoading',
      'firstRender',
      'user',
      'changePassword',
      'userExtradata',
      'user',
      'deviceToken',
      'token'
    ]),
    ...mapState('AppStore', [
      'selectedApp',
      'showTutorial',
      'language',
      'showWebinarPopup'
    ]),
    ...mapState('UserStore', ['token', 'user', 'closedUserCompletion', 'isLoggedIn', 'lastLogin']),
    ...mapState('CompanyStore', ['selectedCompany']),
    ...mapGetters('AppStore', ['getSelectedApp', 'isKeybeApp', 'isBlockOrEnabled']),
    ...mapGetters('UserStore', ['getToken', 'getDarkModeActive', 'isAgent', 'isSuperAdmin', 'isAdminOrAbove', 'getSelectedUserApp']),
    ...mapState('ConversationStore', ['instagramFixDialog']),
    isAutoKBSys () {
      return this.selectedApp?.categories?.includes('car')
    },
    appUUID (): string {
      return this.selectedApp?.uuid || ''
    },
    signin (): string {
      return link.signin
    },
    signup (): string {
      return link.signup
    },
    resetPassword (): string {
      return link.resetPassword
    },
    formPreview (): string {
      return link.formPreview
    },
    invitedWizard (): string {
      return link.invitedWizard
    },
    facebookMobile (): string {
      return link.facebookMobileConfig
    },
    instagramMobile (): string {
      return link.instagramMobileConfig
    },
    loginQuery (): any {
      return this.$route?.query?.firstLogin === 'true'
    },
    assistedSignup (): string {
      return link.assistedSignup
    },
    isFrontOfficeView (): boolean {
      return (
        this.$route.path === this.signin ||
        this.$route.path === this.signup ||
        this.$route.path === this.formPreview ||
        this.$route.path === this.resetPassword ||
        this.$route.path === this.invitedWizard ||
        this.$route.path === this.assistedSignup ||
        this.$route.path === link.firstLogin ||
        this.$route.path.includes(this.facebookMobile.toLowerCase()) ||
        this.$route.path.includes(this.instagramMobile.toLowerCase())
      )
    },
    dialogBackground () {
      return this.$vuetify.theme.dark ? Colors.morningCoffee : Colors.white
    },
    UserInfoCompletionComponent () {
      return UserInfoCompletion
    },
    NewVersionPopUpComponent () {
      return NewVersionPopUp
    },
    currentRoute () {
      return this.$route.path
    }
  },
  // async created () {
  //   Listen for our custom event from the SW registration
  //   document.addEventListener('swUpdated', this.refreshOnUpdate, {
  //     once: true
  //   })
  //   if (this.token) {
  //     await AuthService.validateToken()
  //   }
  //   window.onfocus = async () => {
  //     if (this.token) {
  //       await AuthService.validateToken()
  //     }
  //   }
  // },
  beforeDestroy (): void {
    EventBus.$off('openNotificationCenter--drawer')
    EventBus.$off('closeConfigOnboardingInitial--wizard', this.closeConfigurationOnboarding.bind(this))
    this.eventsController.unsubscribe()
    this.unmountEventToHandleIdle()
    window.onfocus = null
    EventBus.$off('openLostReason--sales', this.openLostReason.bind(this))
    EventBus.$off('selectLostReason--sales', this.cancelDrag.bind(this))
    if (this.appSubscription) this.appSubscription.unsubscribe()
  },
  async mounted () {
    window.addEventListener('updateUserConfig--v6Config', (e) => this.handleUserUpdate(e))
    EventBus.$on('openNotificationCenter--drawer', () => {
      this.notificationCenterOpen = true
    })
    EventBus.$on('openCommissionsModal', () => { this.showComissionsModal = true })
    EventBus.$on('closeConfigOnboardingInitial--wizard', this.closeConfigurationOnboarding.bind(this))
    EventBus.$on('openContactCallWhatsapp', (payload) => {
      this.openContactCallWhatsapp(payload)
    })
    EventBus.$on('openContactCall', (payload) => {
      this.openContactCall(payload)
    })
    store.dispatch('AppStore/setRedirectRoute', '')
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches
    const darkModeActive = this.getDarkModeActive
    this.getBikyConfig()
    if (!darkModeActive) {
      this.$vuetify.theme.dark = !!prefersDark
      this.$store.commit(
        'UserStore/SET_DARK_MODE',
        this.$vuetify.theme.dark ? StatusActive.ACTIVE : StatusActive.INACTIVE
      )
    } else {
      this.$vuetify.theme.dark = operation.areEqual(darkModeActive, StatusActive.ACTIVE)
    }

    if (!this.language) {
      const language = navigator.language
      let lang = language.split('-')[0]
      if (lang !== Languages.ES) {
        lang = Languages.EN
      }
      this.$store.commit('AppStore/SET_APP_LANGUAGE', lang)
    }
    if (this.isAutoKBSys) {
      const hasHidenData = this.selectedApp?.config?.find(
        (config) => config.field === 'HideData'
      ) || false
      // eslint-disable-next-line no-undef
      this.app = structuredClone(this.selectedApp)
      if (!this.app.config) this.app.config = []
      if (!hasHidenData) {
        this.app.config.push({ field: 'HideData', value: '1' })
        console.log(this.app.config, 'update app config')
        this.saveAppInformation()
      }
    }
    loadLanguageAsync(this.language)

    this.cleanTemporalData()
    const url = window.location.hostname
    const bluebirdOldUrl = 'bluebird.keybe.ai'
    if (url === bluebirdOldUrl) {
      const baseURL = process.env.VUE_APP_BASE_KEYBE_URL
      const URL = `${baseURL}conversations?app=${this.getSelectedApp.uuid}&token=${this.getToken}`
      window.location.replace(URL)
    }
    if (this.selectedApp?.uuid && this.isLoggedIn) {
      this.createEventSubscription()
    }

    this.startInterval()
    this.mountEventToHandleIdle()
    this.getUserReadonly()
    setTimeout(() => {
      this.checkNewVersionPopUp()
    }, 120000)
    this.checkDevice()
    if (this.selectedApp?.uuid) {
      console.log('================== MOUNT APP =======================')
      await this.getUser()
      await this.getApp()
      await this.setAppSubscription()
    }
    EventBus.$on('openLostReason--sales', this.openLostReason.bind(this))
    EventBus.$on('selectLostReason--sales', this.cancelDrag.bind(this))
  },
  beforeCreate () {
    const path = this.$route.path

    if (path === link.login) {
      window.location.href = `${process.env.VUE_APP_BASE_KEYBE_URL}/signin`
      return
    }

    if (path === link.register) {
      const query = this.$route.query
      this.$router.push({ path: link.signup, query, replace: true })
    }
  },
  methods: {
    ...mapActions('AppStore', [
      'getAdviserStatus',
      'setShowTutorial',
      'setWebinarPopup',
      'setIsAndroid'
    ]),
    ...mapActions('ConversationStore', [
      'setOneSignalUserId',
      'selectRoom',
      'cleanTemporalData'
    ]),
    ...mapActions('UserStore', ['logout', 'setUserExtradata', 'setLastLogin']),
    ...mapActions('PipelinesStore', ['setSelectedPipeline']),
    ...mapActions('FloatingWindowsStore', [
      'setMaximazedWindow'
    ]),
    checkNewVersionPopUp () {
      const newVersionExtradata = this.user.userData?.find(data => data.property === 'v7_pop_up')
      const newVersionStayInV7 = this.user.userData?.find(data => data.property === 'stay_in_v7')
      if (newVersionStayInV7?.value === 'false') {
        this.showNewVersionPopUp = false
        return
      }
      if (!newVersionExtradata || newVersionExtradata.value === 'false') {
        this.showNewVersionPopUp = true
      }
    },
    closeWhatsAppCall () {
      this.callDialogWhatsapp = false
      this.x = (typeof window !== 'undefined' ? (Math.round(window.innerWidth / 2) - 200) : 100) // center of screen
      this.y = (typeof window !== 'undefined' ? (Math.round(window.innerHeight / 2) - 200) : 100)
    },
    closeCall () {
      this.callDialog = false
      this.x = (typeof window !== 'undefined' ? (Math.round(window.innerWidth / 2) - 200) : 100) // center of screen
      this.y = (typeof window !== 'undefined' ? (Math.round(window.innerHeight / 2) - 200) : 100)
    },
    startDrag (event) {
      this.dragging = true
      this.offsetX = event.clientX - this.x
      this.offsetY = event.clientY - this.y

      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag (event) {
      if (!this.dragging) return
      this.x = event.clientX - this.offsetX
      this.y = event.clientY - this.offsetY
    },
    stopDrag () {
      this.dragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
    openContactCallWhatsapp (payload: { contact: Contact, selectedLine: string }) {
      console.log('Open Whatsapp Call Dialog', payload)
      this.callDialogWhatsapp = true
      this.selectedCallContact = payload.contact
    },
    openContactCall (payload: { contact: Contact, selectedLine: string }) {
      this.callDialog = true
      this.selectedCallContact = payload.contact
      this.selectedCallLine = payload.selectedLine
    },
    extendSession (): void {
      this.sessionExtensionModal = false
      const dispatchActivity = (type: string) => {
        try {
          const ev = new Event(type, { bubbles: true, cancelable: true })
          window.dispatchEvent(ev)
          document.dispatchEvent(ev)
        } catch (e) {
          // ignore
        }
      }

      dispatchActivity('mousemove')
      dispatchActivity('keydown')
      dispatchActivity('touchstart')
    },
    async _logout () {
      await PushNotificationsController.setOneSignalStatus({ active: false })
      await AdviserStatusController.inactiveIfIsAdviser(this.isAgent)
      await AuthService.logout()
      this.logout()
      window.location.href = `${process.env.VUE_APP_BASE_KEYBE_URL}/signin`
    },
    async getBikyConfig (): Promise<void> {
      const config: BikyConfig = await BikyConfigUseCases.getBikyConfig(this.bikyConfigController, {
        token: this.token,
        appUUID: this.selectedApp?.uuid
      })

      BikyStoreController.setConfig(config)

      this.bikyConfig = config
    },
    handleUserUpdate (e): void {
      if (e?.detail?.user?.uuid) {
        this.$store.commit('UserStore/SET_KEYBE_USER', e?.detail?.user)
        this.$store.commit('UserStore/SET_USER_EXTRADATA', e?.detail?.user?.userData || [])

        const extradata = e?.detail?.user?.userData || []
        const mode = extradata.find((item: LoggedUserExtradata) => item.property === 'mode')
        const lang = e.detail.lang
        if (mode.value) {
          this.$vuetify.theme.dark = mode.value === 'dark'
          this.$store.commit('UserStore/SET_DARK_MODE', this.$vuetify.theme.dark ? StatusActive.ACTIVE : StatusActive.INACTIVE)
        }
        if (lang) {
          loadLanguageAsync(lang)
          this.$store.commit('AppStore/SET_APP_LANGUAGE', lang)
        }
      }
    },
    async saveAppInformation (): Promise<void> {
      try {
        const data = {
          app: this.app,
          token: this.token
        }
        await AppsUseCases.updateAppInfo(this.appsController, data)
      } catch (e) {
        console.error(e)
      }
    },
    async getUser () {
      if (!this.token || !this.user.uuid) return
      const data: dataToGetUser = {
        token: this.token,
        uuid: this.user?.uuid || ''
      }
      await UserUseCases.getUser(this.userController, data)
    },
    // get app
    async getApp () {
      if (this.loading) return
      if (!this.token || !this.isLoggedIn) return
      try {
        console.log('==================GET APP=======================')
        this.loading = true
        const data: dataToGetApp = {
          uuid: this.selectedApp?.uuid || '',
          token: this.token
        }
        const response = await AppsUseCases.getApp(this.appsController, data)
        if (response) {
          const app = response?.data
          this.loading = false
          this.$store.commit('AppStore/SET_SELECTED_APP', app)
          console.log('==================APP STATUS:=======================')
          console.log(app?.status?.toUpperCase() || 'NO STATUS')
          if (app.status !== 'active') {
            this.$router.replace(link.payment)
          } else {
            if (this.user && this.user.uuid) this.checkShowUserInfoCompletion()
            if (this.$route.path === link.payment) this.$router.replace(link.home)
          }
        }
      } catch (error) {
        this.loading = false
      }
    },
    setAppSubscription () {
      if (!this.token || !this.isLoggedIn || !this.selectedApp?.uuid) return
      console.log('===============START APP SUBSCRIPTION================')
      this.appSubscription = this.eventsApolloClient
        .subscribe({
          query: SubscriptionOnApp,
          variables: {
            appUuid: this.selectedApp?.uuid
          }
        })
        .subscribe((res) => {
          const app = res?.data?.onApp?.payload || {}
          if (Object.keys(app).length) {
            const parsed = JSON.parse(app)
            console.log('===============APP DATA CHANGED================')
            console.log(parsed)
            const activeApp = parsed?.status === 'active'
            if (!activeApp) {
              store.commit('AppStore/SET_SELECTED_APP', parsed)
              this.$router.replace(link.payment)
            } else if (this.selectedApp.status !== 'active' && activeApp) {
              store.commit('AppStore/SET_SELECTED_APP', parsed)
              this.$router.replace(link.home)
              if (this.user && this.user.uuid && this.token) this.checkShowUserInfoCompletion()
            }
            console.log('===============================================')
          }
        })
    },
    checkDevice (): void {
      const userAgent = window?.navigator?.userAgent || ''
      if (userAgent) {
        const isAndroid: boolean = userAgent.includes('Android') || false
        this.setIsAndroid(isAndroid)
      }
    },
    checkShowUserInfoCompletion (): void {
      if (this.closedUserCompletion || this.$route.path === link.payment || !this.user?.uuid) return

      console.log('==================CHECK USER INFO COMPLETION=======================')

      const data: dataToGetTermsByTeamMember = { appUUID: this.selectedApp?.uuid, user: this.user }
      const acceptedTerms = this.getSelectedUserApp.accept_terms === 1
      const isOwner = AppsUseCases.isUserOwner(this.appsController, data)

      // const appIncomplete = [
      //   this.selectedApp?.email,
      //   this.selectedApp?.phone?.length >= 5,
      //   this.selectedApp?.timeZone,
      //   this.selectedApp?.lang,
      //   this.selectedApp?.country,
      //   this.selectedApp?.defaultCountryCode
      // ].some(field => !field)

      const userIncomplete = [
        this.user.name,
        this.user.lastName,
        this.user.email,
        this.user.phone,
        this.user.address_country,
        this.user.address_province,
        this.user.address_city,
        this.user.birthday,
        acceptedTerms
      ].some(field => !field)

      if ((!this.isSuperAdmin && userIncomplete && !isOwner)) {
        // console.log('App Incomplete:', {
        //   email: this.selectedApp?.email,
        //   phone: this.selectedApp?.phone?.length >= 5,
        //   timeZone: this.selectedApp?.timeZone,
        //   lang: this.selectedApp?.lang,
        //   country: this.selectedApp?.country,
        //   defaultCountryCode: this.selectedApp?.defaultCountryCode
        // })
        console.log('User Incomplete:', {
          name: this.user.name,
          lastName: this.user.lastName,
          email: this.user.email,
          phone: this.user.phone,
          address_country: this.user.address_country,
          address_province: this.user.address_province,
          address_city: this.user.address_city,
          birthday: this.user.birthday,
          acceptedTerms
        })
        this.showUserInfoCompletion = true
      }
    },
    getUserReadonly (): void {
      const readData: dataToCheckUserOwner = {
        appUUID: this.selectedApp?.uuid,
        user: this.user
      }

      AppsUseCases.isUserReadonly(this.appsController, readData)
    },
    cancelDrag (): void {
      this.showDragCardLostReason = false
      this.fromStep = {}
      this.toStep = {}
      this.draggedCard = {}
      this.indexDraggedCard = -1
    },
    openLostReason (data: {
      fromStep: Step,
      toStep: Step,
      draggedCard: Card,
      draggedCardIndex: number
    }): void {
      this.fromStep = data.fromStep
      this.toStep = data.toStep
      this.draggedCard = data.draggedCard
      this.indexDraggedCard = data.draggedCardIndex
      this.showDragCardLostReason = true
    },
    async getOnboardingStep (): Promise<void> {
      const step: number = await OnboardingUseCases.getOnboardingStep(this.onboardingController)
      this.showOnboardingInitial = step === 1
      this.showOnboardingTutorial = step === 2
      this.rerender++
    },
    closeOnboarding (): void {
      this.showOnboardingInitial = false
      this.$router.replace({ query: { ...this.$route.query, firstLogin: undefined } })
      OnboardingUseCases.setOnboardingStep(this.onboardingController, 2)
      this.showOnboardingTutorial = true
      setTimeout(() => {
        this.rerender++
      }, 200)
    },
    closeConfigurationOnboarding (): void {
      this.showOnboardingTutorial = false
      EventBus.$emit('closeConfigOnboarding--wizard')
      this.rerender++
    },
    validateOneSignal () {
      if (!this.$OneSignal) {
        return
      }

      this.$OneSignal.isPushNotificationsEnabled((isEnabled) => {
        if (isEnabled) {
          this.$OneSignal.getUserId((userId) => {
            this.oneSignalUserId = userId
          })
        } else {
          this.$OneSignal.showNativePrompt()
          this.$OneSignal.on('subscriptionChange', (isSubscribed) => {
            if (isSubscribed) {
              this.$OneSignal.getUserId((userId) => {
                this.oneSignalUserId = userId
              })
            } else {
              this.oneSignalUserId = 'null'
            }
          })
        }
      })
    },
    createEventSubscription (): void {
      this.eventsController.unsubscribe()
      // New Events Subsctiption
      if (!this.user?.uuid) {
        return
      }

      return EventsUseCases.subscribe(
        this.eventsController,
        {
          userUUID: this.user.uuid
        },
        this.onEvent.bind(this)
      )
    },
    onEvent (response: EventSuscriptionGetter): void {
      if (!response.status) {
        EventBus.$emit('toast', 'error', 'On event error')
        return
      }

      const data: onUser = response?.data?.onUser
      const isCloseSession: boolean =
        data?.type === GraphqlEventTypes.CLOSE_SESSION || false
      const isDevice: boolean = data?.deviceToken === this.deviceToken || false

      if (isCloseSession && isDevice) {
        return this.closeSession(data.message)
      }

      if (data?.type === GraphqlEventTypes.TASK_NOTIFICATIONS) {
        return this.taskNotification(data.payload)
      }
    },
    closeSession (message: string): void {
      EventBus.$emit('toast', 'error', message)
      setTimeout(async () => {
        await AdviserStatusController.inactiveIfIsAdviser(this.isAgent)
        this.logout()
        window.location.href = `${process.env.VUE_APP_BASE_KEYBE_URL}/signin`
      }, 500)
    },
    taskNotification (payload: string): void {
      EventBus.$emit('toast', 'success', this.$t('newTaskReminder'))
      EventBus.$emit('new-task-reminder', payload)
    },
    refreshOnUpdate (event: any) {
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!event.detail || !event.detail.waiting) return
      // send message to SW to skip the waiting and activate the new SW
      event.detail.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
    // Interval functions
    startInterval () {
      if (this.interval) {
        this.cancelInterval()
      }

      this.interval = setInterval(() => {
        this.idleTime++
      }, 60000)
    },
    cancelInterval () {
      window.clearInterval(this.interval)
    },
    mountEventToHandleIdle () {
      // events to clear idle time counter on
      const events = [
        'load',
        'mousemove',
        'mousedown',
        'click',
        'scroll',
        'keypress'
      ]

      for (const i in events) {
        window.addEventListener(events[i], () => {
          if (this.idleTime >= 5) {
            EventBus.$emit('IDLE:reset')
          }
          this.idleTime = 0
        })
      }
    },
    unmountEventToHandleIdle () {
      const events = [
        'load',
        'mousemove',
        'mousedown',
        'click',
        'scroll',
        'keypress'
      ]

      for (const i in events) {
        window.removeEventListener(events[i], () => {
          this.idleTime = 0
        })
      }
    },
    async setOnboardingStarted (): Promise<void> {
      await OnboardingUseCases.setOnboardingStarted(this.onboardingController, this.token)
      setTimeout(() => {
        this.getOnboardingStep()
      }, 500)
    }
  },
  watch: {
    loginQuery () {
      if (this.loginQuery) {
        this.setOnboardingStarted()
      }
    },
    async oneSignalUserId (newId) {
      if (!this.isLoggedIn) return

      if (newId) {
        this.setOneSignalUserId(newId)
        if (this.isLoggedIn) {
          const currentStatus = await this.getAdviserStatus(this.user.userId)
          await PushNotificationsController.setOneSignalStatus({
            active: currentStatus === UserStates.Online
          })
        }
      } else {
        if (this.oneSignalRetryAttempts < 3) {
          this.oneSignalRetryAttempts++
          setTimeout(() => {
            this.validateOneSignal()
          }, 1000)
        }
      }
    },
    selectedApp (newValue) {
      this.setSelectedPipeline(null)
      this.eventsController.unsubscribe()
      if (newValue?.uuid && this.isLoggedIn) {
        this.createEventSubscription()
        EventBus.$emit('closeDrawer--details')
        this.selectRoom(null)
        this.getUserReadonly()
      }
    },
    appUUID: {
      immediate: true,
      handler (newVal) {
        if (this.appSubscription) this.appSubscription.unsubscribe()
        if (newVal) {
          this.setAppSubscription()
        }
      }
    },
    selectedCompany: {
      immediate: true,
      deep: true,
      handler () {
        this.cleanTemporalData()
      }
    },
    changePassword (newVal) {
      const query = this.$route.query
      if (query?.wizard) {
        this.showChangePasswordDialog = false
      }
      if (this.$route.path !== link.onboarding) {
        this.showChangePasswordDialog = false
      }
      if (!this.user?.terms) {
        this.showChangePasswordDialog = false
      }
      this.showChangePasswordDialog = newVal
    },
    language (newVal) {
      loadLanguageAsync(newVal)
    },
    isLoggedIn (newVal, oldVal) {
      if (newVal) {
        if (newVal === true && oldVal === false) this.setAppSubscription()
        this.validateOneSignal()
      }
    },
    currentRoute (newVal, oldVal) {
      if (newVal !== oldVal && this.selectedApp?.uuid) {
        this.getApp()
      }
    }
  }
}
